"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidABN = exports.formatABN = void 0;
/**
 * Formats any input into the canonical Australian Business Number (ABN)
 * presentation: 11 digits split 2-3-3-3 and separated by spaces.
 */
var formatABN = function (raw) {
    var digits = raw.replace(/\D/g, '');
    if (digits.length < 11) {
        return raw;
        throw new Error('ABN must contain at least 11 digits');
    }
    var abn = digits.slice(0, 11);
    return "".concat(abn.slice(0, 2), " ").concat(abn.slice(2, 5), " ").concat(abn.slice(5, 8), " ").concat(abn.slice(8));
};
exports.formatABN = formatABN;
/**
 * Optional checksum validator (official modulus-89 test).
 * https://abr.business.gov.au/Help/AbnFormat
 */
var isValidABN = function (raw) {
    var cleaned = raw.replace(/\D/g, '');
    if (cleaned.length !== 11)
        return false;
    var weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    var digits = cleaned
        .split('')
        .map(function (d, i) { return (i === 0 ? Number(d) - 1 : Number(d)); });
    var sum = digits.reduce(function (acc, digit, i) { return acc + digit * weights[i]; }, 0);
    return sum % 89 === 0;
};
exports.isValidABN = isValidABN;
